import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const PadStyle = ({track, padRef, isSelected, playing}) => { 
    useEffect(() => {
        if (!padRef.current) {
            return '';
        }
        if (playing) {
            padRef.current.className = "pad-slot pressed";
        } else {
            let classes = padRef.current.className.split(" ").filter(
                x => x !== "pressed");
            padRef.current.className = classes.join(" ");
        }

        if (isSelected) {
            padRef.current.className += " selected";
        } else {
            let classes = padRef.current.className.split(" ").filter(
                x => x !== "selected");
            padRef.current.className = classes.join(" ");
        }
        // padRef.current.className += " pushable";

        if (track.muted) {
            padRef.current.className += " muted";
        }
    }, [playing, isSelected]);
    return '';
}

const mapStateToProps = (state, props) => {
    let slot = props.track;
    let ret = {};
    if (slot) {
        let trackTriggers = state.tracks.triggers[slot.trackNumber];
        if (trackTriggers) {
            for (let track in trackTriggers) {
                if (trackTriggers[track]) {
                    ret.playing = true;
                }
            }
        }
        if (!ret.playing) {
            ret.playing = (slot.notesTriggered && Object.keys(slot.notesTriggered).length > 0);
        }
        /*
        ret.playing = (trackTriggers && Object.keys(trackTriggers).some(
            t => trackTriggers[t])); //||
            */
            //
        // ret.notesTriggered = slot.notesTriggered;
        ret.isSelected = slot && state.mix.selectedTrack === slot.trackNumber;
    }
    return ret;
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PadStyle);
